import { render } from "./App.vue?vue&type=template&id=45c4a514"
const script = {}

import "./App.vue?vue&type=style&index=0&id=45c4a514&lang=scss"

import exportComponent from "/Users/haoxunming/Desktop/flowbox公司项目/flowbox/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__